var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center mt-4 mb-4"},[_c('img',{staticClass:"mb-4",attrs:{"src":require(`@/assets/img/loading.gif`),"alt":"","width":"150"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }